<template>
<v-container fluid><h3 class='primary--text text-xs-left mt-4 mb-4'>Apprenticeship Information</h3>
      <v-layout row wrap v-for="apprenticeship in Apprenticeship" :key="apprenticeship.ID" class='extra-pad'>
        <appretice-info :disableFields="disableFields" :apprenticeship="apprenticeship" class="mt-2 mb-4"></appretice-info>
      </v-layout>
</v-container>
</template>

<script>
import ApprenticeshipInfoVue from './Education/ApprenticeshipInfo.vue';
export default {
  name: 'Apprenticeship',
  props: {
    Apprenticeship: Array, 
    disableFields: Boolean
  },
  data() {
    return {
      menu: false,
      menu2: false
    }
  },
  methods: {},

  components: {
    'appretice-info' : ApprenticeshipInfoVue
  },
  watch: {
    Apprenticeship: {
      handler(val) {
        this.$emit('input', val)
      },
      deep: true,
    },
  },
}
</script>